<template>
    <div class="module">
        <helpInfo :helpData='helpData'></helpInfo>
        <div class="module-container">
            <!-- 选项卡 -->
            <div class="list-container"
                 :style="{width:isView?'60%':'100%'}">
                <Tabs :animated="false"
                      @on-click='changeTab'
                      type="card"
                      :value="tabValue">
                    <TabPane :label="$t('未读消息')"
                             v-if="hasPermission('CF06')"
                             name="unread">
                        <rcTable ref="unreadRcTable"
                                 :tableAttr="unreadTableAttr"
                                 :checkPms="hasPermission('CF0601')"
                                 @onSelectChange="unreadSelected"
                                 v-if="tabValue === 'unread'">
                            <Button @click="refreshUnReadedTable"
                                    v-if="hasPermission('CF0601')"
                                    class="tootip-btn"
                                    slot="tootipL">
                                <i class="icon-refresh-o-2"></i>
                            </Button>
                            <Button :disabled="unreadSelectedList.length === 0"
                                    @click="readMsg(null)"
                                    v-if="hasPermission('CF0603')"
                                    slot="tootipL">{{this.$t('标为已读')}}</Button>
                        </rcTable>
                    </TabPane>
                    <TabPane :label="$t('已读消息')"
                             v-if="hasPermission('CF07')"
                             name="readed">
                        <rcTable ref="readedRcTable"
                                 :tableAttr="readedTableAttr"
                                 :checkPms="hasPermission('CF0601')"
                                 @onSelectChange="readedSelected"
                                 v-if="tabValue === 'readed'">
                            <Button @click="refreshReadedTable"
                                    class="tootip-btn"
                                    v-if="hasPermission('CF0601')"
                                    slot="tootipL">
                                <i class="icon-refresh-o-2"></i>
                            </Button>
                            <Button v-if="hasPermission('CF0603')"
                                    :disabled="readedSelectedList.length === 0"
                                    slot="tootipL"
                                    @click="removeMsg(null)">{{this.$t('删除')}}</Button>
                        </rcTable>
                    </TabPane>
                    <TabPane :label="$t('公告')"
                             v-if="hasPermission('CF08')"
                             name="announcement">
                        <announcement></announcement>
                    </TabPane>
                </Tabs>
            </div>
            <div class="detail-container"
                 :style="{width:isView?'40%':'0'}">
                <div class="content"
                     v-if="isView">
                    <div class="msg-header">{{$t('消息详情')}}
                        <Icon type="ios-close"
                              size="26"
                              class="pull-right close-icon"
                              @click="closeDetail" />
                    </div>
                    <div class="title">{{$t(crruentMsg.msgTitle)}}</div>
                    <div class="time">
                        <i class="icon-time-o"></i>&nbsp;&nbsp;<span>{{crruentMsg.sendDate}}</span>
                    </div>
                    <div class="msg-details-content"
                         v-html="crruentMsg.msgContent"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helpInfo from '@c/basic/helpinfo'
import rcTable from '@/views/components/basic/rcTable'
import announcement from '@/views/console/announcement/index.vue'
import API from '@/service/api.js'
export default {
    name: 'MessageList',
    components: {
        helpInfo,
        rcTable,
        announcement
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('消息中心')
            },
            isView: false,
            crruentMsg: {},
            saveViewMsg: [],
            tabValue: 'unread',
            // 未读消息table
            unreadSelectedList: [],
            unreadTableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_MSG_INFO, false),
                    params: {
                        readFlag: '02'
                    }
                },
                isMultiSelect: true,
                searchShow: false,
                referenceVal: 800,
                columns: [
                    {
                        title: this.$t('标题内容'),
                        key: 'msgTitle',
                        className: 'ellipsis',
                        resizable: true,
                        width: 300,
                        render: (h, params) => {
                            return h('a', {
                                class: !this.hasPermission('CF0602') ? 'disabled-per link' : 'link',
                                on: {
                                    click: () => {
                                        this.hasPermission('CF0602') && this.showDetail(params.row)
                                    }
                                }
                            }, this.$t(params.row.msgTitle))
                        }
                    },
                    {
                        title: this.$t('创建时间'),
                        key: 'sendDate',
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 150
                    },
                    {
                        title: this.$t('操作'),
                        width: 80,
                        fixed: 'right',
                        render: (h, params) => {
                            return h('div', { class: 'tbl-btn-div' }, [
                                h('a', {
                                    class: { 'disabled-per': !this.hasPermission('CF0603') },
                                    on: {
                                        click: () => { this.hasPermission('CF0603') && this.readMsg(params.row) }
                                    }
                                }, this.$t('标为已读'))
                            ])
                        }
                    }
                ]
            },
            // 已读消息table
            readedSelectedList: [],
            readedTableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_MSG_INFO, false),
                    params: {
                        readFlag: '01'
                    }
                },
                searchShow: false,
                isMultiSelect: true,
                referenceVal: 800,
                columns: [
                    {
                        title: this.$t('标题内容'),
                        key: 'msgTitle',
                        className: 'ellipsis',
                        resizable: true,
                        width: 300,
                        render: (h, params) => {
                            return h('a', {
                                class: !this.hasPermission('CF0602') ? 'disabled-per link' : 'link',
                                on: {
                                    click: () => {
                                        this.hasPermission('CF0602') && this.showDetail(params.row)
                                    }
                                }
                            }, this.$t(params.row.msgTitle))
                        }
                    },
                    {
                        title: this.$t('创建时间'),
                        key: 'sendDate',
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 150
                    },
                    {
                        title: this.$t('操作'),
                        key: '',
                        width: 80,
                        fixed: 'right',
                        render: (h, params) => {
                            return h('div', { class: 'tbl-btn-div' }, [
                                h('a', {
                                    class: !this.hasPermission('CF0603') ? 'disabled-per' : '',
                                    on: {
                                        click: () => { this.hasPermission('CF0603') && this.removeMsg(params.row) }
                                    }
                                }, this.$t('删除'))
                            ])
                        }
                    }
                ]
            }
        }
    },
    created () {
        const name = this.getUrlParam('tab')
        if (name) {
            this.tabValue = name
        }
    },
    methods: {
        // 获取url中的参数值
        getUrlParam (name) {
            let str = ''
            const arr = (window.location.href).split('?')
            const data = arr.length > 1 ? (arr[1].split('&')) : null
            for (const i in data) {
                const subdata = data[i].split('=')
                if (subdata[0] === name) {
                    str = subdata[1]
                }
            }
            return str
        },
        changeTab (name) {
            if (!(this.tabValue === name && this.tabValue === 'unread')) {
                this.isView = false
            }
            this.tabValue = name
        },
        showDetail (rowData) {
            if (!this.isView) {
                this.isView = true
            }
            this.crruentMsg = rowData
            // 记录所有看过的消息
            if (this.tabValue === 'unread') {
                this.saveViewMsg.push(rowData.msgSid)
            }
        },
        closeDetail () {
            this.readMsgInFirstTab(true)
        },
        // 未读消息列表选择
        unreadSelected (rows) {
            this.unreadSelectedList = rows
        },
        // 已读消息列表选择
        readedSelected (rows) {
            this.readedSelectedList = rows
        },
        // 刷新已读信息列表
        refreshReadedTable () {
            this.$refs.readedRcTable && this.$refs.readedRcTable.refreshTable({ readFlag: '01' })
        },
        // 刷新未读信息列表
        refreshUnReadedTable () {
            this.$refs.unreadRcTable && this.$refs.unreadRcTable.refreshTable({ readFlag: '02' })
        },
        readMsg (rowData) {
            const params = []
            if (rowData) {
                params.push(rowData.msgSid)
            } else {
                // 批量操作
                this.unreadSelectedList.forEach(item => {
                    params.push(item.msgSid)
                })
            }

            if (params.length > 0) {
                this.$Modal.confirm({
                    title: this.$t('请选择'),
                    content: this.$t('您确认要将这') + '<span style="color:#ff6a01;font-weight:600">' + params.length + '</span>' + this.$t('条消息标记为已读吗？'),
                    onOk: () => {
                        this.axios.put(this.urlFormat(API.PUT_MSG_READ, false), {
                            ids: params
                        }).then(res => {
                            this.refreshUnReadedTable()
                        })
                    }
                })
            }
        },
        readMsgInFirstTab (flag) {
            if (this.saveViewMsg.length > 0 && this.hasPermission('CF0603')) {
                this.axios.put(this.urlFormat(API.PUT_MSG_READ, false), {
                    ids: this.saveViewMsg
                }).then(res => {
                    this.saveViewMsg = []
                    if (flag) {
                        this.isView = false
                        this.refreshUnReadedTable()
                        this.refreshReadedTable()
                    }
                })
            } else {
                this.saveViewMsg = []
                this.isView = false
            }
        },
        removeMsg (rowData) {
            const params = []
            if (rowData) {
                params.push(rowData.msgSid)
            } else {
                // 批量操作
                this.readedSelectedList.forEach(item => {
                    params.push(item.msgSid)
                })
            }
            if (params.length > 0) {
                this.$Modal.confirm({
                    title: this.$t('请选择'),
                    content: this.$t('您确认要将这') + '<span style="color:#ff6a01;font-weight:600">' + params.length + '</span>' + this.$t('条消息删除吗？'),
                    onOk: () => {
                        this.axios.delete(this.urlFormat(API.DELETE_MSG, false), {
                            data: { ids: params }
                        }).then(res => {
                            this.refreshReadedTable()
                        })
                    }
                })
            }
        }
    },
    beforeDestroy () {
        this.readMsgInFirstTab(false)
    }

}
</script>

<style lang="less" scoped>
.module-container {
    display: flex;
    height: 100%;
    width: 100%;
    .list-container {
        transition: width 0.4s;
        height: 100%;
    }
    .detail-container {
        height: 100%;
        transition: width 0.4s;
        // padding-top: 30px;
        .content {
            width: 100%;
            height: 100%;
            padding: 10px 20px 0 20px;
            // margin-left: 20px;
            border-left: 1px solid #e9e9e9;
            margin-top: -14px;
            .msg-header {
                height: 30px;
                border-bottom: 1px dashed #e9e9e9;
                .close-icon:hover {
                    cursor: pointer;
                    color: #ff6a01;
                }
            }
            .title {
                width: 100%;
                height: 30px;
                margin-top: 20px;
                line-height: 30px;
                font-size: 16px;
                font-weight: 500;
                color: #999;
                text-align: center;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .time {
                width: 100%;
                height: 30px;
                line-height: 30px;
                font-size: 12px;
                font-weight: 300;
                text-align: center;
                color: #aaa;
                span {
                    position: relative;
                    top: -1px;
                }
            }
            .msg-details-content {
                margin-top: 20px;
                font-size: 12px;
                color: #808080;
            }
        }
    }
}
</style>
